/** Trust stats shown in the home Story section + Reviews page header. */
const trustStats = [
  { id: 'since', value: '2009', label: 'Serving since' },
  { id: 'largest', value: '2,200+', label: 'Largest wedding celebration' },
  { id: 'veg', value: '100%', label: 'Pure vegetarian, satvik kitchens' },
  { id: 'daily', value: 'Daily', label: 'Catering for corporates & institutions' },
];

/** Compact 3-cell stats for the Reviews page hero strip. */
export const reviewsPageStats = [
  { id: 'since', value: '2009', label: 'Serving since' },
  { id: 'largest', value: '2,200+', label: 'Largest event served' },
  { id: 'veg', value: '100%', label: 'Pure vegetarian' },
];

export default trustStats;
